export default "__VITE_ASSET__CuK9ZBm7__"